/**
 * Waarom de verstuurknop van het noodkanaal (nog) grijs is, of `null` als hij werkt.
 *
 * Bij een doelgroep van nul mensen stond de knop actief en weigerde de server pas na het
 * bevestigingsvenster (testrapport 28 okt.). Een noodmelding die niemand bereikt, is geen
 * noodmelding: dat hoort de beheerder te zien vóór hij "NOOD" typt. Zolang het aantal nog geteld
 * wordt (`undefined`), blokkeert dit niet: dan beslist de server.
 */
export function sendBlock(
  mode: '' | 'drill' | 'real',
  count: number | undefined,
): 'chooseMode' | 'noRecipients' | null {
  if (mode === '') return 'chooseMode';
  if (count === 0) return 'noRecipients';
  return null;
}
